var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFramework(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.25017V12.0002M9 8.25017L6 6.75017M9 8.25017L12 6.75017M8.8323 15.6663L3.2073 12.8538C3.08025 12.7903 3 12.6604 3 12.5184V5.48193C3 5.33989 3.08025 5.21005 3.20729 5.14652L8.8323 2.33402C8.93787 2.28124 9.06213 2.28124 9.16771 2.33402L14.7927 5.14652C14.9197 5.21005 15 5.33989 15 5.48193V12.5184C15 12.6604 14.9197 12.7903 14.7927 12.8538L9.16771 15.6663C9.06213 15.7191 8.93787 15.7191 8.8323 15.6663Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFramework);
export default __webpack_public_path__ + "static/media/IconFramework.7cd1834ef9d1d000fc69bb6ea92fb5c9.svg";
export { ForwardRef as ReactComponent };